import { Button, Dialog, Notify, Image, Collapse, Avatar, Input   } from '@nutui/nutui-react';
import { ArrowDown } from '@nutui/icons-react'
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import 星爷 from '../img/head.png'
import 至尊宝 from '../img/至尊宝.png'
import 阿咸 from '../img/阿咸.png'
import { bigNumberTransform, refreshPageWithTimestamp } from '../common'
import dayjs from 'dayjs';

function Init(props) {

    const { loginType: type, serverList: server, selectServerCb, setLoading, setPercent } = props

    const centerCss = { display: 'flex', alignItems: 'center', justifyContent: 'center' }

    const _this = useRef({
        uuid: null,
        selectServerFlag: false,
        intervalId: null,
        percentIntervalId: null,
        percent: 0,
        num: 60,
        getCombUserIntervalId: null,
        endTime: null,
        isQrCode: false,
    }).current

    const [loginType, setLoginType] = useState(type)
    const [serverList, setServerList] = useState(server)

    const [phoneLoginDialog, setPhoneLoginDialog] = useState(false)

    const [verificationCodeLabel, setVerificationCodeLabel] = useState('获取验证码')

    const [phone, setPhone] = useState('')
    const [authCode, setAuthCode] = useState('')
    const [showQrDialog, setShowQrDialog] = useState({ show: false })


    const [activeName, setActiveName] = useState()

    const [dialogStatus, setDialogStatus] = useState({
        show: false,
        title: '请扫码',
        content: <div></div>,
        hideConfirmButton: true,
        hideCancelButton: false,
        onConfirm: () => { }
    })

    useEffect(() => {
        setLoginType(type)
        server && server.serverList.serverList.reverse()
        setServerList(server)
    }, [type, server])



    const wxLogin = () => { getQRCode() }
    const phoneLogin = () => { setPhoneLoginDialog(true) }

    const getQRCode = async () => {
        const now = dayjs()
        if (now.get('day') === 5 && now.get('hour') >= 5 && now.get('hour') < 7) {
            Dialog.alert({
                title: '警告',
                content: "咸鱼服务器维护中，请不要在周五的5点到7点扫码登录",
                hideCancelButton: true,
                confirmText: '确认',
            })
            return
        }

        axios.get('/v1/getUid').then(({ data }) => {
            const { qrCodeUrl } = data.body

            if (data.code === 400) {
                Dialog.alert({
                    title: '警告',
                    content: data.msg,
                    hideCancelButton: true,
                    confirmText: '确认',
                })
                return
            }

            let dialogParam = {
                show: true,
                url: qrCodeUrl
            }

            if (_this.qrCodeUrl === qrCodeUrl) {
                setShowQrDialog(dialogParam)
                return
            }

            _this.qrCodeUrl = qrCodeUrl

            setShowQrDialog(dialogParam)
            // const commonStr = `https://open.weixin.qq.com/connect/qrcode`
            const uuid = qrCodeUrl.substring(qrCodeUrl.lastIndexOf("/") + 1)
            setTimeout(() => {
                _this.getCombUserIntervalId = setInterval(() => {
                    axios.get('/v1/getCombUser', { uuid }).then(({data}) => {
                        if (data.code === 201) {
                            return
                        }
                        if (data.code === 200) {
                            const { body } = data
                            body.serverList.reverse()
                            setServerList(body)
                            setLoginType(2)
                            setShowQrDialog({...showQrDialog, show: false})
                        } else if (data.code === 400) {
                            Dialog.alert({
                                title: '警告',
                                content: data.msg,
                                hideCancelButton: true,
                                confirmText: '确认',
                            })
                            getQRCode()
                        } else if (data.code === 401) {
                            Dialog.alert({
                                title: '警告',
                                content: data.msg,
                                hideCancelButton: true,
                                confirmText: '确认',
                            })
                            setShowQrDialog({...showQrDialog, show: false})
                        }
                        _this.getCombUserIntervalId && clearInterval(_this.getCombUserIntervalId)
                    }).catch((err) => {
                        _this.getCombUserIntervalId && clearInterval(_this.getCombUserIntervalId)
                        window.location.reload()
                    })
                }, 2000)
            }, 3000)
        })
    }

    const confirmLayout = (user, serverName) => {
        let headImg = 阿咸
        if (user.lordSkinId === 0) headImg = 阿咸
        if (user.lordSkinId === 1) headImg = 星爷
        if (user.lordSkinId === 2) headImg = 至尊宝
        let serverNameLabel = serverName
        if (serverName === "26501服") {
            serverNameLabel = `月光宝盒`
        } else if (serverName === "27001服") {
            serverNameLabel = `桃花仙人`
        }

        return (
            <div style={{ ...centerCss, flexDirection: 'column', marginRight: '30px' }}>
                <Avatar src={headImg} shape="square" size="small" />
                <div>{`区服: ${serverNameLabel}`}</div>
                <div>{`名称: ${user.name}`}</div>
                <div>{`战力: ${bigNumberTransform(user.power)}`}</div>
            </div>
        )

    }

    const selectServer = (server, user, encryptUser) => {
        const { serverName } = server
        const { serverId } = user


        if (!serverId) {
            Notify.warning("请选择服务器", { duration: 1000 })
            return
        }



        setDialogStatus({
            show: true,
            // title: '请确认信息',
            content: confirmLayout(user, serverName),
            hideConfirmButton: false,
            hideCancelButton: false,
            onConfirm: () => {
                if (_this.selectServerFlag) return
                _this.selectServerFlag = true

                setDialogStatus({
                    ...dialogStatus,
                    show: false
                })
                setServerList(null)
                _this.percent = 0
                _this.percentIntervalId = setInterval(() => {
                    _this.percent += Math.floor(Math.random() * 10)
                    if (_this.percent >= 100) {
                        clearInterval(_this.percentIntervalId)
                        _this.percent = 99
                        setPercent(_this.percent)
                        return
                    }
                    setPercent(_this.percent)
                }, 200)

                axios.post('/v1/selectServer', {
                    serverId,
                    encryptUser: encryptUser
                }).then(({ data }) => {

                    if (data.code === 200) {
                        _this.getDailyUserId = setInterval(() => {
                            axios.get('/v1/getDailyUser').then(({data}) => {
                                if (data.code === 400) {
                                    return
                                }
                                if (data.code === 200) {
                                    setPercent(100)
                                    setLoginType(3)
                                    selectServerCb(encryptUser)
                                }
                                _this.percentIntervalId && clearInterval(_this.percentIntervalId)
                                _this.getDailyUserId && clearInterval(_this.getDailyUserId)
                            }).catch((err) => {
                                _this.percentIntervalId && clearInterval(_this.percentIntervalId)
                                _this.getDailyUserId && clearInterval(_this.getDailyUserId)
                                refreshPageWithTimestamp();
                            })
                        }, 2000)


                    } else {
                        Dialog.alert({
                            title: '警告',
                            content: data.msg,
                            hideCancelButton: true,
                            confirmText: '确认',
                            closeOnOverlayClick: false
                        })
                        // selectServerCb(encryptUser, "error")
                    }
                }).finally(() => {
                    _this.selectServerFlag = false
                    // setLoading(false)
                    // setPercent(0)
                    // _this.percent = 0
                    // if (_this.percentIntervalId) {
                    //     clearInterval(_this.percentIntervalId)
                    // }

                })
            }
        })

        return

    }

    const onCancelDialog = () => setDialogStatus({
        ...dialogStatus,
        show: false
    })

    const onChangeActivateName = val => {
        setActiveName(val.length >= 2 ? [val[val.length -1]] : val)
    }

    const getSelectServerLayout = (serverData, recommendId) => {


        const { serverList: server = {}, encryptUser } = serverData
        let { roles, serverList } = server

        if (!roles || Object.keys(roles).length === 0) {
            return <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: 'red', fontSize: '20px', fontWeight: 'bold'}}>
                <p>当前账号没有注册角色 </p>
                <p style={{ textAlign: 'center'}}>请联系客服</p>
            </div>
        }
        // activeName={activeName ? activeName :[recommendId + ""]}
        return (
            <>
                <Collapse activeName={activeName ? activeName :[recommendId + ""]} expandIcon={<ArrowDown />} style={{ width: '100vh' }} onChange={onChangeActivateName}>

                    {
                        serverList.map((server, index) => {
                            let users = []
                            for (let key in roles) {
                                const serverId = server.id + ""
                                if (serverId === key) users.push(roles[key])
                                if (serverId.length === 1) {
                                    if ("100000" + serverId === key + "") users.push(roles[key])
                                    if ("200000" + serverId === key + "") users.push(roles[key])
                                } else if (serverId.length === 2) {
                                    if ("10000" + serverId === key + "") users.push(roles[key])
                                    if ("20000" + serverId === key + "") users.push(roles[key])
                                } else if (serverId.length === 3) {
                                    if ("1000" + serverId === key + "") users.push(roles[key])
                                    if ("2000" + serverId === key + "") users.push(roles[key])
                                } else if (serverId.length === 4) {
                                    if ("100" + serverId === key + "") users.push(roles[key])
                                    if ("200" + serverId === key + "") users.push(roles[key])
                                } else if (serverId.length === 5) {
                                    if ("10" + serverId === key + "") users.push(roles[key])
                                    if ("20" + serverId === key + "") users.push(roles[key])
                                } else if (serverId.length === 6) {
                                    if ("1" + serverId === key + "") users.push(roles[key])
                                    if ("2" + serverId === key + "") users.push(roles[key])
                                }
                                // if (key.slice(serverId.length * -1) === serverId) {
                                //     users.push(roles[key])
                                // }
                            }
                            let serverNameLabel = server.serverName
                            if (server.serverName === "26501服") {
                                serverNameLabel = `月光宝盒`
                            } else if (server.serverName === "27001服") {
                                serverNameLabel = `桃花仙人`
                            }

                            return users.length > 0 &&
                                <Collapse.Item title={serverNameLabel} name={server.id + ""}>
                                    <div style={centerCss}>
                                        {users.map(user => {

                                            let headImg = 阿咸
                                            if (user.lordSkinId === 0) headImg = 阿咸
                                            if (user.lordSkinId === 1) headImg = 星爷
                                            if (user.lordSkinId === 2) headImg = 至尊宝

                                            return <div key={user.serverId} style={{ ...centerCss, flexDirection: 'column', marginRight: '30px' }} onClick={() => selectServer(server, user, encryptUser)}>
                                                <Avatar src={headImg} shape="square" size="small" />
                                                <div>{`${user.name}`}</div>
                                                <div>{`战力${bigNumberTransform(user.power)}`}</div>
                                            </div>
                                        })}
                                    </div>
                                </Collapse.Item>
                        })

                    }
                </Collapse>
            </>
        )
    }

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>

                {loginType === 1 &&
                    <>
                        <Button type="primary" style={{ position: 'absolute', top: '50%', left: '3%', width: '45%' }} onClick={wxLogin}>
                            微信登录
                        </Button>
                        <Button type="primary" style={{ position: 'absolute', top: '50%', right: '3%', width: '45%' }} onClick={phoneLogin}>
                            手机号登录
                        </Button>
                    </>
                }
                {
                    loginType === 2 && serverList && getSelectServerLayout(serverList, serverList.serverList.recommendId)
                }

                <Dialog
                    title={dialogStatus.title}
                    // content= {getQrImage()}
                    confirmText='确认'
                    cancelText='取消'
                    hideConfirmButton={dialogStatus.hideConfirmButton}
                    hideCancelButton={dialogStatus.hideCancelButton}
                    onConfirm={dialogStatus.onConfirm}
                    onCancel={onCancelDialog}
                    closeOnOverlayClick={false}
                    visible={dialogStatus.show}>
                    {dialogStatus.content}
                </Dialog>
            </div>


            <Dialog
                title="手机号登录"
                confirmText='确认'
                cancelText='取消'
                hideConfirmButton={false}
                hideCancelButton={false}
                onConfirm={() => {
                    if (!phone || phone.length !== 11) {
                        Notify.warn('请输入正确的手机号')
                        return
                    }

                    if (!authCode) {
                        Notify.warn('请输入验证码')
                        return
                    }
                    setLoading(true)


                    axios.post('/v1/loginPhone', {phone, authCode}).then(({data}) => {
                        if (data.code === 200) {
                            const { body } = data
                            setServerList(body)
                            setLoginType(2)
                            setPhoneLoginDialog(false)

                            if (_this.intervalId) { // 这是验证码的定时器
                                clearInterval(_this.intervalId)
                            }
                        } else if (data.code === 400) {
                            Dialog.alert({
                                title: '警告',
                                content: data.msg,
                                hideCancelButton: true,
                                confirmText: '确认',
                            })
                        }

                    }).finally(() => {
                        setLoading(false)
                        setPhoneLoginDialog(false)
                        setPhone('')
                        setAuthCode('')
                    })
                }}
                onCancel={() => {
                    setPhoneLoginDialog(false)
                    setPhone('')
                    setAuthCode('')
                }}
                closeOnOverlayClick={false}
                visible={phoneLoginDialog}>
                <Input
                        placeholder="请输入手机号"
                        style={{ '--nutui-input-padding': '10px' }}
                        value={phone}
                        type="number"
                        maxLength={11}
                        onChange={value => {
                            setPhone(value)
                        }}
                />
                <div
                    style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#fff',
                    }}
                >

                    <Input
                        placeholder="请输入短信验证码"
                        style={{ '--nutui-input-padding': '10px' }}
                        value={authCode}
                        onChange={value => setAuthCode(value)}
                    />
                    <div className="right">
                    <Button type="primary" size="small" onClick={() => {
                        if (!phone || phone.length !== 11) {
                            Notify.warn('请输入正确的手机号')
                            return
                        }

                        if (verificationCodeLabel !== '获取验证码') {
                            Notify.warn('不要重复获取验证码')
                            return
                        }
                        _this.intervalId = setInterval(() => {
                            _this.num--
                            if (_this.num <= 0) {
                                setVerificationCodeLabel("获取验证码")
                                if (_this.intervalId) {
                                    clearInterval(_this.intervalId)
                                }
                            } else {
                                setVerificationCodeLabel(_this.num)
                            }
                        }, 1000)
                        setLoading(true)


                        axios.post('/v1/getPhoneCode', {phone}, ({data}) => {
                            if (data.code === 200) {
                                Notify.success('发送成功， 请输入验证码')
                            }
                        }).finally(() => {
                            setLoading(false)
                        })
                    }}>
                        {verificationCodeLabel}
                    </Button>
                    </div>
                </div>
            </Dialog>


            <Dialog
                title="请扫码"
                // content= {getQrImage()}
                confirmText='确认'
                cancelText='取消'
                hideConfirmButton={true}
                hideCancelButton={false}
                onCancel={() => setShowQrDialog({...showQrDialog, show: false})}
                closeOnOverlayClick={false}
                visible={showQrDialog.show}>
                <>
                    <Image src={showQrDialog.url} />
                    {/* {showQrDialog.show && _this.endTime &&
                    <div  style={{ width: "100%", textAlign: 'center' }} >
                    <CountDown endTime={_this.endTime} onEnd={() => {
                        Dialog.alert({
                            title: '提示',
                            content: '二维码已过期，请重新获取',
                            onConfirm: () => {
                                setShowQrDialog({...showQrDialog, show: false})
                            }
                        })
                    }} />

                </div>} */}


                 </>
            </Dialog>
        </>
    );
}

export default Init;